import React, { useState } from 'react';
import { global_var } from '../../services/cs-lab-config';
import IdeHeader from "./ide-header";
import { useParams, useLocation } from "react-router-dom";
import { Spin, message } from "antd";

const SqlIde = () => {

    document.title = "CS Lab | SQL IDE";

    let { sqlQueryId } = useParams();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fkResourceId = queryParams.get('fkResourceId');
    const fkActivityMapping = queryParams.get('fkActivityMapping');
    const fkUserActivityMappingId = queryParams.get('fkUserActivityMappingId');
    
    // const userToken = localStorage.getItem("token");
    const userToken = sessionStorage.getItem('token');
    const [isLoading, setShowSpinner] = useState(true); // State to track loading status
    let iframeUrl;

    if (sqlQueryId  && fkResourceId) {
        iframeUrl = global_var.SQLPAD_ENDPOINT + '/queries/' + sqlQueryId + "?fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment&token=" + userToken;
    }else if (!sqlQueryId && fkResourceId) {
        iframeUrl = global_var.SQLPAD_ENDPOINT + "?fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment&token=" + userToken;
    }else if (sqlQueryId && !fkResourceId) {
        iframeUrl = global_var.SQLPAD_ENDPOINT + '/queries/' + sqlQueryId + "?token=" + userToken
    }else {
        iframeUrl = global_var.SQLPAD_ENDPOINT + "?token=" + userToken;
    }

    // Function to handle iframe load event
    const handleIframeLoad = () => {
        var mql = window.matchMedia("(orientation: portrait)");
        // If there are matches, we're in portrait
        if (mql.matches) {
            message.open({
                type: 'warning',
                content: 'For a better experience, switch to landscape mode and refresh',
                duration: 5,
              });
        }
        setShowSpinner(false); // Set loading status to false when iframe content is loaded
    };

    return (
        <div className="container-fluid p-0">
            <div className="row">
                <div className="col">
                    <IdeHeader
                        headerName="SQL IDE"
                    />
                    {isLoading && <div
                        style={{
                            textAlign: "center",
                            marginTop: "10rem",
                        }}
                    >
                        <Spin />
                    </div>}
                    <iframe
                        id="sqlpadIframe"
                        src={iframeUrl}
                        title="Sqlpad"
                        onLoad={handleIframeLoad} // Attach the load event handler
                        style={{
                            width: '100%',
                            height: '100vh',
                            border: 'none',
                            display: isLoading ? 'none' : 'block' // Hide iframe while loading
                        }}
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default SqlIde;
